/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Draft_Your_ChoiceInputs */

const en_us2_draft_your_choice = /** @type {(inputs: Draft_Your_ChoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your pick`)
};

const pt_br2_draft_your_choice = /** @type {(inputs: Draft_Your_ChoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua escolha`)
};

const es_419_draft_your_choice = /** @type {(inputs: Draft_Your_ChoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu elección`)
};

const pt_pt2_draft_your_choice = /** @type {(inputs: Draft_Your_ChoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua escolha`)
};

const fr_fr2_draft_your_choice = /** @type {(inputs: Draft_Your_ChoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton choix`)
};

const de_de2_draft_your_choice = /** @type {(inputs: Draft_Your_ChoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Wahl`)
};

const it_it2_draft_your_choice = /** @type {(inputs: Draft_Your_ChoiceInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua scelta`)
};

/**
* | output |
* | --- |
* | "Your pick" |
*
* @param {Draft_Your_ChoiceInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const draft_your_choice = /** @type {((inputs?: Draft_Your_ChoiceInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Draft_Your_ChoiceInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_draft_your_choice(inputs)
	if (locale === "es-419") return es_419_draft_your_choice(inputs)
	if (locale === "pt-PT") return pt_pt2_draft_your_choice(inputs)
	if (locale === "fr-FR") return fr_fr2_draft_your_choice(inputs)
	if (locale === "de-DE") return de_de2_draft_your_choice(inputs)
	if (locale === "it-IT") return it_it2_draft_your_choice(inputs)
	return en_us2_draft_your_choice(inputs)
});
export { draft_your_choice as "draft.your_choice" }